import { Component, OnInit } from '@angular/core';
import { IonNav, ModalController, NavParams } from '@ionic/angular';
import { ApiService } from 'src/app/services/api/api.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { PosService } from 'src/app/services/pos/pos.service';
import { setDecimals } from 'src/app/utils/decimal';
import { ComponentsService } from '../../../services/components/components.service';

@Component({
	selector: 'app-modify-price',
	templateUrl: './modify-price.component.html',
	styleUrls: ['./modify-price.component.scss'],
})
export class ModifyPriceComponent implements OnInit {

	item: any;
	apply_to: any = 'all';
	note: any;
	new_price: any;

	constructor(
		public modalController: ModalController,
		public components: ComponentsService,
		public navParams: NavParams,
		public api: ApiService,
		public auth: AuthService,
		public pos: PosService,
		public nav: IonNav
	) {
		this.item = this.navParams.get('item');
		this.note = this.item.notes;
		if (this.item.notes == undefined) {
			this.item.notes = '';
		}

	}

	ngOnInit() { }

	editPrice() {
		let total_discount = 0;

		if (this.item.discount_item) {

			if (this.item.discount_item.type == 'percentage') {
				total_discount += Number(Number(this.new_price * (Number(this.item.discount_item.amount) / 100)));

			} else if (this.item.discount_item.type == 'fixed') {
				let new_price = this.new_price - this.item.discount_item.amount;

				if (new_price < 0) {
					total_discount += this.new_price;
				} else {
					total_discount += this.item.discount_item.amount;
				}
			}
		}

		let already_in_order = this.navParams.get('already_in_order');

		if (this.apply_to == 'all' || (this.item.quantity == 1 && this.apply_to == 1)) {
			this.item.notes = this.note;
			let new_price = Number(this.new_price) - total_discount;
			if (!already_in_order) {
				this.pos.updateItemPrice(this.item, new_price);
				this.components.showToast('Precio actualizado correctamente.', 'success');
				this.modalController.dismiss();
			} else {
				this.item.price = Number(this.new_price) - total_discount;
				this.item.base_price = Number(this.new_price) - total_discount;

				this.setTaxesItem(this.item);

				this.api.updateDocument(`accounts/${this.auth.account}/ticket_items`, this.item.$key, this.item).then(() => {
					this.components.showToast('Precio actualizado correctamente.', 'success');
					this.modalController.dismiss();
				}, err => {
					console.log(err);
				})
			}
		} else {
			if (!already_in_order) {
				const found = this.pos.items.findIndex(element => element.id == this.item.id);
				this.pos.items[found].quantity = this.item.quantity - this.apply_to;
				this.item.quantity = Number(this.apply_to);
				this.item.price = Number(this.new_price) - total_discount;
				this.item.notes = this.note;
				this.pos.addItem(this.item);
				this.components.showToast('Precio actualizado correctamente.', 'success');
				this.modalController.dismiss();
			} else {
				this.item.quantity = this.item.quantity - this.apply_to;

				this.api.updateDocument(`accounts/${this.auth.account}/ticket_items`, this.item.$key, this.item).then(() => {
					let new_item = this.item;
					new_item.price = Number(this.new_price) - total_discount;
					new_item.base_price = Number(this.new_price) - total_discount;
					new_item.notes = this.note;
					new_item.quantity = Number(this.apply_to);

					this.setTaxesItem(new_item);

					this.api.addDocument(`accounts/${this.auth.account}/ticket_items`, new_item).then(() => {
						this.components.showToast('Precio actualizado correctamente.', 'success');
						this.modalController.dismiss();
					}, err => {
						console.log(err);
					})
				}, err => {
					console.log(err);

				})
			}
		}
	}

	setTaxesItem(element) {
		element.hidden_taxes = 0;
		element.exempt = 0;
		element.quantity = Number(element.quantity);
		const taxes = element.is_variant ? element.parent?.taxes_item : element?.taxes_item;

		if (taxes?.length) {
			const sortedTaxes = taxes.sort((a, b) => {
				if (a.included === b.included) return 0;
				return a.included ? -1 : 1;
			});

			sortedTaxes.forEach(tax => {
				tax.rate = Number(tax.rate);
				tax.exempt = false;

				this.components.getTaxes(element, tax);

				if (this.pos.exempt) {
					const found = this.pos.client.exempt_taxes.some(exempt => exempt.tax_key === tax.$key);
					if (found) {
						tax.exempt = true;
						element.exempt += tax.value;
					}
				}
			});

			// element.hidden_taxes *= element.quantity;
			element.hidden_taxes = setDecimals(element.hidden_taxes, 8);

		}
	}
}
